(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@adobe/aem-core-cif-react-components", [], factory);
	else if(typeof exports === 'object')
		exports["@adobe/aem-core-cif-react-components"] = factory();
	else
		root["@adobe/aem-core-cif-react-components"] = factory();
})(window, function() {
return 